export default {
  parseDate: function (timestamp, dateSegment = 0, abv = false) {
    let removeTime = timestamp.split('T')
    let dateArray = removeTime[0].split('-')
    let months = ['0', 'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December']
    let month = months[parseInt(dateArray[1])]
    if (abv) {
      month = month.substring(0, 3)
    }
    let day = dateArray[2]
    if (day[0] === '0') {
      day = day.substring(1)
    }
    let output = 0
    if (dateSegment === 'month') {
      output = month
    } else if (dateSegment === 'day') {
      output = day
    } else {
      output = month + ' ' + day + ', ' + dateArray[0]
    }
    return output
  },
  goToUrl: function (url) {
    if (url) {
      if (!url.startsWith('http')) {
        url = 'https://' + url
      }
      window.open(url, '_blank')
    }
  },
  amPmConvert: function (time) {
    // Check correct time format and split into components
    time = time.toString().match(/^(\d|[01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]
    if (time.length > 1) {
      time = time.slice(1)
      time[5] = +time[0] < 12 ? 'am' : 'pm'
      time[0] = +time[0] % 12 || 12
    }
    // remove seconds from array if present - they're captured in the fourth (3) slot of the array
    time[3] = ''
    return time.join('')
  },
  parseTimestamp: function (timestamp, part = 'date') {
    let output = ''
    let dayTimeArray = timestamp.split('T')
    if (part === 'time') {
      output = this.amPmConvert(dayTimeArray[1].slice(0, 5))
    } else if (part === 'date') {
      output = dayTimeArray[0]
    }
    return output
  }
}
